function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from "react";
import { ThemeContext } from "styled-components";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-50%",
  y: "-50%",
  width: "200%",
  height: "200%",
  filterUnits: "objectBoundingBox",
  id: "video-play-mark_svg__a"
}, React.createElement("feOffset", {
  dy: 20,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 13,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M259.2 464c-114.834 0-208-93.166-208-208s93.166-208 208-208 208 93.166 208 208-93.166 208-208 208M256 0C114.651 0 0 114.651 0 256s114.651 256 256 256c141.35 0 256-114.651 256-256S397.35 0 256 0",
  mask: "url(#video-play-mark_svg__video-play-mark_svg__mask-3)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("use", null);

var SvgVideoPlayMark = React.memo(function (props) {
  var theme = useContext(ThemeContext);
  return React.createElement("svg", _extends({
    viewBox: "0 0 516 530"
  }, props), _ref, React.createElement("g", {
    filter: "url(#video-play-mark_svg__a)",
    fill: theme.white100,
    transform: "translate(2)"
  }, _ref2, _ref3));
});
export default SvgVideoPlayMark;